import React, { useRef } from 'react';
import SelectExamLevelTrigger from './components/SelectExamLevelTrigger';
import useData from './useData';
const SelectExamLevel = ({ value, onChange, style, ...inputLayoutProps }) => {
    const [, actions] = useData({ value, onChange });
    const anchorRef = useRef(null);
    return (React.createElement(SelectExamLevelTrigger, { ref: anchorRef, value: value, style: style, ...inputLayoutProps, onPress: () => actions.initiateSelectionFlow(anchorRef) }));
};
export default SelectExamLevel;
